module.exports = __webpack_public_path__ + "img/563-684460.png";